export const PAYMENT_FLOW = 'paymentflow'; // used to identify sign up -> subscribe flow
export const COUPON_FLOW = 'couponflow'; // used to identify coupon -> subscribe
export const SUBSCRIBE_PAIR_FLOW = 'subscribepairflow'; // used to identify /subscribepair -> pairingSuccess flow
export const SHOW_UPSELL = 'showupsell'; // param to trigger premium upsell page
export const subFlowTypes = {
  subscribe: 'subscribe',
  renew: 'renew',
  update: 'update',
};
